import { createSlice } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

const guestSlice = createSlice({
    name: 'guest',
    initialState: {
        guest: {},
        isGuestLoggedIn: false,
        isGuestAuthLoading: true,
        refreshData: false
    },
    reducers: {
        loggedGuest: (state, action) => {
            state.guest = action.payload;
            state.isGuestLoggedIn = true;
            state.isGuestAuthLoading = false;
        },
        restoreGuest: (state, action) => {
            state.guest = action.payload;
            state.isGuestLoggedIn = true;
            state.isGuestAuthLoading = false;
        },
        loggOutGuest: (state, action) => {
            state.guest = {};
            state.isGuestLoggedIn = false;
            state.isGuestAuthLoading = false;
            Cookies.remove('gAuthToken');
        },
        loggOutGuestChangePassword: (state, action) => {
            state.guest = {};
            state.isLoggedIn = false;
            state.isAuthLoading = false;
            Cookies.remove('gAuthToken');
        },
        setAuthLoadingGuest: (state, action) => {
            state.isGuestAuthLoading = action.payload;
        },
        refreshDataGuest: (state, action) => {
            state.refreshData = !state.refreshData;
        }
    },
});

export const { loggedGuest, restoreGuest, loggOutGuest, loggOutGuestChangePassword, setAuthLoadingGuest, refreshDataGuest } =
    guestSlice.actions;
export default guestSlice.reducer;
